var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2679 28H30.041V91.993H32.2679V28Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8026 84.9139H36.4551V64.2974C36.4551 63.5558 37.0563 62.9551 37.7986 62.9551H45.4664C46.2087 62.9551 46.81 63.5558 46.81 64.2974V84.9139H46.8026ZM38.6819 82.6891H44.5831V65.1799H38.6819V82.6891Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8158 84.914H50.4609V69.0293C50.4609 68.2877 51.0622 67.687 51.8045 67.687H59.4723C60.2146 67.687 60.8158 68.2877 60.8158 69.0293V84.914ZM52.6878 82.6892H58.589V69.9118H52.6878V82.6892Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8315 84.9136H64.4766V59.3135C64.4766 58.5719 65.0778 57.9712 65.8201 57.9712H73.4879C74.2302 57.9712 74.8315 58.5719 74.8315 59.3135V84.9136ZM66.7034 82.6888H72.6046V60.196H66.7034V82.6888Z",
    fill: "#00A3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8373 84.9134H78.4824V46.4983C78.4824 45.7567 79.0837 45.156 79.826 45.156H87.4938C88.2361 45.156 88.8373 45.7567 88.8373 46.4983V84.9134ZM80.7093 82.6885H86.6105V47.3882H80.7093V82.6885Z",
    fill: "#00A3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3475 59.1913L36.7812 57.6102L50.0162 44.5237L54.4254 48.9329L62.2194 41.124L66.1313 45.0359L82.8476 28.327L84.4212 29.9007L66.1313 48.1906L62.2194 44.2788L54.4254 52.0802L50.0088 47.6636L38.3475 59.1913Z",
    fill: "#2DCDAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7478 36.2468H82.5209V30.2269H76.501V28H84.7478V36.2468Z",
    fill: "#2DCDAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 34.0071H28V36.2319H31.1547V34.0071Z",
    fill: "#00A3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 44.7454H28V46.9702H31.1547V44.7454Z",
    fill: "#00A3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 55.4763H28V57.7011H31.1547V55.4763Z",
    fill: "#00A3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 66.2148H28V68.4397H31.1547V66.2148Z",
    fill: "#00A3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 76.946H28V79.1709H31.1547V76.946Z",
    fill: "#00A3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0081 88.8481H40.7812V92H43.0081V88.8481Z",
    fill: "#00A3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7581 88.8481H51.5312V92H53.7581V88.8481Z",
    fill: "#00A3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4983 88.8481H62.2715V92H64.4983V88.8481Z",
    fill: "#00A3FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2464 88.8481H73.0195V92H75.2464V88.8481Z",
    fill: "#00A3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9886 88.8481H83.7617V92H85.9886V88.8481Z",
    fill: "#00A3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92 87.6843H28V89.9091H92V87.6843Z",
    fill: "#00A3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 31,
    stroke: "#09547E",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.ee2d0ddd1df8c37d79a5594768ca5f06.svg";
export { ForwardRef as ReactComponent };